
import moment from "moment";
import Box from "@mui/material/Box";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { experienceEntrySx, experienceMarkerSx } from "../styles";
import tokens from "@/theme/tokens";

export interface ExperienceRecord {
  id: number;
  title?: string | null;
  organization_name?: string | null;
  description?: string | null;
  start_date?: string | null;
  end_date?: string | null;
  present?: boolean | null;
}

interface ExperienceEntryProps {
  experience: ExperienceRecord;
  editExperience: (id: number) => void;
  isUsersProfile: boolean;
}

const formatDate = (value?: string | null) =>
  moment.utc(value).local().format("MMM DD, YYYY");

const ExperienceEntry = ({
  experience,
  editExperience,
  isUsersProfile,
}: ExperienceEntryProps) => (
  <Box sx={experienceEntrySx}>
    <Box sx={experienceMarkerSx} />
    <Stack
      direction="row"
      spacing={1}
      sx={{ alignItems: "center", justifyContent: "space-between" }}
    >
      <Typography
        variant="overline"
        sx={{ color: "grey.600", letterSpacing: "1.5px" }}
      >
        {formatDate(experience.start_date)} -{" "}
        {experience.present ? "Present" : formatDate(experience.end_date)}
      </Typography>
      {isUsersProfile && (
        <IconButton
          aria-label="edit experience"
          onClick={() => editExperience(experience.id)}
          size="small"
          sx={{ color: tokens.color.accentTeal }}
        >
          <EditOutlinedIcon fontSize="small" />
        </IconButton>
      )}
    </Stack>
    <Typography variant="body1" sx={{ fontWeight: "bold" }}>
      {experience.title}
    </Typography>
    <Typography variant="body1">{experience.organization_name}</Typography>
    <Typography variant="body2" sx={{ color: "grey.800", mt: 1 }}>
      {experience.description}
    </Typography>
  </Box>
);

export default ExperienceEntry;
